import type { ColDef } from 'ag-grid-community';
import { type FC, useState } from 'react';
import { DataTable } from '../DataTable';

type HowYouHeardAboutUsReportsTableProps = {
  refreshHandler: () => Promise<void>;
  searchString: string;
  tableData: any;
};

export const HowYouHeardAboutUsReportsTable: FC<HowYouHeardAboutUsReportsTableProps> = ({
  refreshHandler,
  searchString,
  tableData,
}: HowYouHeardAboutUsReportsTableProps) => {
  const [columns] = useState<ColDef<any>[]>([
    { field: 'period', headerName: 'PERIOD', flex: 2, sortable: true },
    {
      field: 'howDidYouHearAboutUs',
      headerName: 'HOW YOU HEARD ABOUT US',
      flex: 2,
      sortable: true,
    },
    {
      field: 'count',
      headerName: 'COUNT',
      flex: 1,
      sortable: true,
    },
    {
      field: 'percentage',
      headerName: 'PERCENTAGE',
      flex: 1,
      sortable: true,
      valueFormatter(params) {
        return `${params.value}%`;
      },
    },
  ]);

  return (
    <DataTable
      refreshHandler={refreshHandler}
      searchString={searchString}
      changeState={0}
      rowData={tableData}
      columnDefs={columns}
    />
  );
};
